module.exports = __webpack_public_path__ + "img/bluesky3100_15.5f3bd1cf.jpg";